import {
    collection,
    doc,
    getDocs,
    setDoc,
    limit,
    orderBy,
    query,
    // startAfter,
    where,
    deleteDoc,
    getDoc,
    updateDoc,
    serverTimestamp,
    startAfter,
    // startAt
} from "firebase/firestore";
import { auth, db } from '../firebase';

export const getConnections = async (lastConnection) => {
    const connectionRef = query(
        collection(db, `users/${auth.currentUser?.uid}/connections`), 
        orderBy('dateConnected'),
        limit(26),
        startAfter(lastConnection || 0),
    );
    const querySnapshot = await getDocs(connectionRef);
    const results = [];
    querySnapshot.docs.map(async (cdoc) => {
        const profileRef = doc(db, `users/${cdoc.data().userId}/profile`, "userProfile");
        const profile = await getDoc(profileRef);
        const pr = profile.data();
        results.push({
            profilePicture: pr?.profilePicture,
            firstName: pr?.firstName,
            lastName: pr?.lastName,
            city: pr?.city,
            state: pr?.state,
            date: doc.date,
            ...cdoc.data(),
            id: cdoc.id
        }) 
    });
    return results;
}

export const loadConnections = async () => {
    const connectionRef = query(
        collection(db, `users/${auth.currentUser?.uid}/connections`),
        orderBy('dateConnected'),
    );
    const querySnapshot = await getDocs(connectionRef);
    const results = [];
    querySnapshot.docs.map(async (cdoc) => {
        const profileRef = doc(db, `users/${cdoc.data().userId}/profile`, "userProfile");
        const profile = await getDoc(profileRef);
        const pr = profile.data();
        results.push({
            profilePicture: pr?.profilePicture,
            firstName: pr?.firstName,
            lastName: pr?.lastName,
            city: pr?.city,
            state: pr?.state,
            date: doc.date,
            ...cdoc.data(),
            id: cdoc.id
        })
    });
    return results;
}

export const getNeighbors = async (lastNeigbour,  connections) => {
    const usersRef = query(
        collection(db, "users"), 
        orderBy("userID"),
        limit(26),
        startAfter(lastNeigbour || 0)
    );
    const querySnapshot = await getDocs(usersRef);
    const records = [];
    await querySnapshot.docs.filter((data) => (data.data().userID !== auth?.currentUser.uid)).map(async (di) => {

        const profileRef = doc(db, `users/${di.id}/profile`, "userProfile");
        const profile = await getDoc(profileRef);

            if (profile.city === auth.currentUser?.city || profile?.state === auth.currentUser?.state || profile.country === auth.currentUser?.country){

                const connectionRef = query(collection(db, `users/${di.id}/connections`));
                const connectionsQS = await getDocs(connectionRef);
                 
                const neighbourConnections = connectionsQS.docs.filter((conn) => (conn.data().userId !== auth?.currentUser?.uid))
                const isConnectedToMe = connectionsQS.docs.find((conn) => conn.data()?.userId === auth?.currentUser?.uid)

                if(!isConnectedToMe){
                    const pr = profile.data();
                    
                    const data = {
                        ...di.data(), id: di.id, 
                        profilePicture: pr?.profilePicture,
                        firstName: pr?.firstName,
                        lastName: pr?.lastName,
                        city: pr?.city,
                        mutual: neighbourConnections.length || 0,
                        state: pr?.state,
                    }

                    records.push({ ...data});
                }

            }
    });

    return records
}

export const removeConnection = async (connectionToRemove) => {
    const connectionRef = doc(db, `users/${auth.currentUser?.uid}/connections`, connectionToRemove);
    await deleteDoc(connectionRef);
    return 'success';
}

export const addConnection = async (userId) => {
    // Add My Connections Record
    const connectionRef = doc(collection(db, `users/${auth?.currentUser?.uid}/connections`));
    await setDoc(connectionRef, {
        userId,
        dateConnected: serverTimestamp(),
    });
    // Add Another Connection Record
    const newConnectionsRef = doc(collection(db, `users/${userId}/connections`));
    await setDoc(newConnectionsRef, {
        userId: auth?.currentUser?.uid,
        dateConnected: serverTimestamp(),
    });
    return 'success';
}

/** Business */
export const getBusinesses = async (lastBusiness, iAmTheOwner = false) => {
    const businessRef = iAmTheOwner ? 
        query(
            collection(db, "businesses"), 
            where('owner', '==', auth.currentUser?.uid), 
            orderBy("businessName"),
            limit(10), 
            startAfter(lastBusiness || 0)
        ) 
        : query(
            collection(db, "businesses"), 
            orderBy("owner"), 
            where('owner', '!=', auth.currentUser?.uid), 
            orderBy('businessName'),
            limit(10),
            startAfter(lastBusiness || 0)
        );
    const results = [];
    const querySnapshot = await getDocs(businessRef);
    querySnapshot.docs.map(async (bdoc) => {
        const ownerRef = doc(db, `users/${bdoc.owner}/profile`, "userProfile");
        const onwerData = await getDoc(ownerRef);
        const owner = onwerData.data();
        const result = {
            ownerName: owner?.firstName + ' ' + owner?.lastName,
            ownerLocation: owner?.city + ', ' + owner?.state,
            ownerPhoto: owner?.profilePicture,
            ...bdoc.data(),
            id: bdoc.id
        }

        results.push(result)
    });
    
    return [...results];
}

export const addBusiness = async (data) => {
    const businessRef = doc(collection(db, `businesses`));
    await setDoc(businessRef, {
        ...data,
        owner: auth.currentUser?.uid
    });
    return 'success';
}

export const updateBusiness = async (data, businessId) => {
    const businessRef = doc(db, `businesses`, businessId);
    await updateDoc(businessRef, {
        ...data,
    });
    return 'success';
}


export const getGroups = async (lastDoc, iAmMemberOf = false) => {
    const groupRef = iAmMemberOf ? 
        query(
            collection(db, "groups"),
            where('members', 'array-contains', auth?.currentUser?.uid), 
            where("owner", "==", auth?.currentUser?.uid),
            orderBy("groupName", "asc"),
            limit(10), 
            startAfter(lastDoc || 0)
        )
        : query(
            collection(db, "groups"),
            orderBy("owner", "asc"),
            where("owner", "!=", auth?.currentUser?.uid),
            orderBy("groupName", "asc"),
            limit(10), 
            startAfter(lastDoc || 0)
        );

    const querySnapshot = await getDocs(groupRef);
    const results = [];
    querySnapshot.forEach( async gdoc => {
        const gdata = gdoc.data();
        const members = [];
        await gdata?.members?.map(async (member) => {
            const profileRef = doc(db, `users/${member}/profile`, "userProfile");
            const profile = await getDoc(profileRef);
            const pr = profile.data();
            members.push({
                firstName: pr?.firstName,
                lastName: pr?.lastName,
                email: pr?.email,
                profilePicture: pr?.profilePicture,
                phoneNumber: pr?.phoneNumber,
                userId: member
            })
        }) 
        results.push({
            ...gdata,
            members,
            id: gdoc.id
        })
    });
    return results;
}

export const joinGroup = async(groupData, groupId) => {
    const groupRef = doc(db, `groups`, groupId);
    await updateDoc(groupRef, {
        ...groupData,
        members: groupData?.members.push(auth?.currentUser.uid)
    });

    return 'success'
}

export const addGroup = async (data) => {
    const groupRef = doc(collection(db, `groups`));
    await setDoc(groupRef, {
        ...data, members: [
            auth?.currentUser?.uid,
        ],
        owner: auth.currentUser?.uid
    });
    return 'success';
}

export const updateGroup = async (data, groupId) => {
    const groupRef = doc(db, `groups`, groupId);
    await updateDoc(groupRef, {
        ...data,
    });
    return 'success';
}

export const updatePost = async (post) => {

}

export const createPost = async (data, setNewPost) => {
    const postRef = doc(collection(db, `posts`));
    await setDoc(postRef, {
        ...data,
        createdAt: serverTimestamp(),
        creator: auth.currentUser?.uid
    });
    setNewPost(true);
    return 'success';
}

export const likePost = async (postId) => {
    const noteRef = doc(collection(db, `posts/${postId}/likes`));
    await setDoc(noteRef, {
        userId: auth?.currentUser?.uid,
        date: serverTimestamp(),
    });
    return "success";
}

export const commentOnPost = async (postId, data) => {
    const noteRef = doc(collection(db, `posts/${postId}/comments`));
    await setDoc(noteRef, {
        userId: auth?.currentUser?.uid,
        ...data,
        date: serverTimestamp(),
    });
    return "success";
}

export const getPosts = async (lastPost, groupId) => {
    const postRef = groupId ? 
        query(collection(db, "posts"), where("group", groupId), orderBy('createdAt', 'asc'), limit(26), startAfter(lastPost || 0) )
        : query(collection(db, "posts"), orderBy('createdAt', 'asc'), limit(26), startAfter(lastPost || 0))
    const querySnapshot = await getDocs(postRef);

    const results = [];
    
     querySnapshot.forEach(async (pdoc) => {
        const post = pdoc?.data();
        const creatorData = doc(db, `users/${post.creator}/profile`, "userProfile");
        const creator = await getDoc(creatorData);

        const likesRef = query(collection(db, `posts/${pdoc.id}/likes`));
        const likesSanps = await getDocs(likesRef);

        const commentsRef = query(collection(db, `posts/${pdoc.id}/likes`));
        const cquerySnapshot = await getDocs(commentsRef);

        const likes = likesSanps?.docs.map(ld => ({ ...ld.data(), id: ld.id}));
        const comments = cquerySnapshot?.docs.map(ld => ({ ...ld.data(), id: ld.id}));
        const data = {
            ...pdoc.data(),
            likes,
            creator: creator.data(),
            comments,
            id: pdoc.id
        }
        results.push(data);
    });
    return results
}